import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { filter, sortBy, map, findIndex, delay } from 'lodash';
import { seq } from 'async';
import Fa from 'react-fontawesome';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Tooltip, OverlayTrigger, Button } from 'react-bootstrap';
import SearchField from '../../../../components/search-field';
import ProgressBar from '../../../../components/progress-bar';
// Import Actions
import {
  fetchAllExclusionReasons,
  reorderExclusionReasons,
  fetchExclusionReason,
} from '../../SetupActions';

// Import Selectors
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import AddExclusionReasonForm from './AddExclusionReasonForm';
import styles from './styles.css';


// a little function to help us with reordering the result

const mutatedReorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);
  return list;
};


class ExclusionReasonPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false,
      reasons: [],
      errors: null,
      draggedId: null,
      dragging: false,
      editingReason: null,
      newReasonTemplate: null,
      loadingTemplate: false,
    };
    this.onDragEnd = this.onDragEnd.bind(this);
    this.requestEditReason = this.requestEditReason.bind(this);
    this.handleUpdateReason = this.handleUpdateReason.bind(this);
    this.requestAddNewReason = this.requestAddNewReason.bind(this);
    this.hanldeDeleteReason = this.hanldeDeleteReason.bind(this);
  }

  componentDidMount() {
    this.loadReasons();
  }


  requestEditReason(editingReason) {
    this.setState({ editingReason });
  }


  handleUpdateReason(reason) {
    const { reasons } = this.state;
    let newReasons = [...reasons];
    const currentIndex = findIndex(newReasons, { _id: reason._id });

    if (currentIndex >= 0) {
      newReasons[currentIndex] = reason;
    } else {
      newReasons.push(reason);
    }

    this.setState({ reasons: sortBy(newReasons, 'sort_order'), draggedId: reason._id }, () => {
      delay(() => {
        this.setState({ draggedId: null }); // blink effect
      }, 1000);
    });
  }

  hanldeDeleteReason(reason) {
    const newReasons = filter(this.state.reasons, (r) => {
      return r._id !== reason._id;
    });
    this.setState({ reasons: newReasons });
  }

  onDragEnd(result) {
    const { isAccount } = this.props;
    const { source, destination } = result;
    if (!this.state.dragging && source.index !== destination.index) {
      const destinationList = [...this.state.reasons];

      const draggedId = this.state.reasons[source.index] ? this.state.reasons[source.index]._id : null;

      mutatedReorder(
        destinationList,
        source.index,
        destination.index,
      );

      const positions = map(destinationList, '_id');
      this.setState({ dragging: true, draggedId: null }, () => {
        this.props.dispatch(reorderExclusionReasons({ ids: positions }, isAccount))
          .then(
            ({ reasons }) => {
              this.setState({ reasons, dragging: false, draggedId });
            },
            () => {
              this.setState({ reasons: false, draggedId });
            },
          );
      });
    }
  }

  requestAddNewReason() {
    const { isAccount } = this.props;
    if (this.state.loadingTemplate) {
      return;
    }
    if (this.state.newReasonTemplate) {
      this.requestEditReason({ ...this.state.newReasonTemplate });
      return;
    }
    this.setState({ loadingTemplate: true }, () => {
      this.props.dispatch(fetchExclusionReason('new', isAccount))
        .then(
          ({ reason }) => {
            this.setState({ loadingTemplate: false, newReasonTemplate: reason }, () => {
              this.requestEditReason({ ...reason });
            });
          },
          () => {
            this.setState({ loadingTemplate: false, newReasonTemplate: {} }, () => {
              this.requestEditReason({});
            });
          },
        );
    });
  }


  loadReasons() {
    const { isAccount } = this.props;
    this.setState({ loaded: false, loading: true, reasons: [] }, () => {
      this.props.dispatch(fetchAllExclusionReasons(isAccount))
        .then(
          ({ reasons }) => {
            this.setState({ loading: false, loaded: true, reasons });
          },
          (e) => {
            this.setState({ loading: false, loaded: false, errors: e.data ? e.data.message : e });
          },
        );
    });
  }

  renderCreateNewButton() {
    return null;
  }

  renderRow(reason, index) {
    const { dragging, reasons, draggedId } = this.state;

    const { type, location: { pathname } } = this.props;

    const tip = reason.is_system ? (
      <Tooltip id={`${reason._id}-system-automation`}>
        <div>System default</div>
      </Tooltip>
    ) : null;

    const blinking = draggedId === reason._id;

    let arrowName = 'arrows-v';
    if (reasons.length > 1) {
      if (index === 0) {
        arrowName = 'long-arrow-down';
      } else if (index === reasons.length - 1) {
        arrowName = 'long-arrow-up';
      }
    }
    if (dragging) {
      arrowName = 'spinner';
    }

    return (
      <Draggable draggableId={reason._id} key={reason._id} index={index}>
        {(provided, snapshot) => (
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            className={`${snapshot.isDragging ? styles.dragging : null}`}
            style={provided.draggableProps.style}
          >
            <td
              width="40"
              className="text-center"
              {...provided.dragHandleProps}
            >
              <Fa
                name={arrowName}
                spin={dragging}
              />
            </td>
            <td className="text-center" width="40">
              <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={tip}>
                <Fa name="star" className={reason.is_system ? 'text-warning' : 'invisible'} />
              </OverlayTrigger>
            </td>
            <td>
              <span className={blinking ? 'animated flash' : ''}>
                {reason.label}
              </span>
            </td>
            <td>
              <span className={`text-uppercase label ${reason.enabled ? 'label-success' : 'label-danger'}`}>{reason.enabled ? 'Enabled' : 'Disabled'}</span>
            </td>
            <td>
              <Button bsSize="sm" onClick={() => { this.requestEditReason(reason); }}><Fa name="edit" /> Edit</Button>
            </td>
          </tr>
        )}
      </Draggable>
    );
  }

  renderTable() {
    const { reasons } = this.state;
    return (
      <div>
        <div className="clearfix">
          <div className="pull-right">
            {this.renderCreateNewButton()}
          </div>
        </div>
        <p />
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Fragment>
            <table className={`table table-bordered table-condensed table-striped ${styles.table}`}>
              <thead>
                <tr>
                  <th width="40" />
                  <th colSpan="2">Exclusion Reason</th>
                  <th width="100">Enabled</th>
                  <th width="100">Actions</th>
                </tr>
              </thead>
              <Droppable droppableId="drop">
                {(provided, snapshot) => (
                  <tbody
                    ref={provided.innerRef}
                    className={snapshot.isDraggingOver ? styles.DraggingOver : null}
                  >
                    {reasons.map((s, index) => this.renderRow(s, index))}
                    {provided.placeholder}
                  </tbody>
                )}
              </Droppable>
            </table>
          </Fragment>
        </DragDropContext>
      </div>
    );
  }


  renderContent() {
    const { loading, errors, reasons } = this.state;

    if (loading) {
      return (
        <div>
          <ProgressBar />
        </div>
      );
    }
    if (errors !== null) {
      return (
        <div className="alert alert-danger">{errors}</div>
      );
    }
    if (reasons.length === 0) {
      return <div className="alert alert-danger">No exclusion reasons found.</div>;
    }
    return this.renderTable();
  }

  renderModal() {
    const { editingReason } = this.state;
    const { isAccount } = this.props;

    return (
      <AddExclusionReasonForm
        open={editingReason !== null}
        reason={(editingReason || {})}
        onClose={() => { this.setState({ editingReason: null }); }}
        onCreate={this.handleUpdateReason}
        onUpdate={this.handleUpdateReason}
        onDelete={this.hanldeDeleteReason}
        isAccount={isAccount}
      />
    );
  }

  renderAddButton() {
    const { isAccount } = this.props;
    return (
      <div className="clearfix">
        <Button className="pull-right" bsStyle="primary" onClick={this.requestAddNewReason}>
          <Fa name="plus" /> Add New {isAccount ? 'Experience' : 'Decision'} Exclusion Reason
        </Button>
      </div>
    );
  }

  render() {
    const { isAccount } = this.props;
    return (
      <div>
        <Helmet title="Decision Reasons | Exclusion Reasons Setup" />
        <div className="well">
          The following exclusion reasons will apply for {isAccount ? 'account' : 'opportunity'}-based automation:
        </div>
        {this.renderAddButton()}
        {this.renderContent()}
        {this.renderModal()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const { match: {  params: { source } } } = ownProps;
  return {
    organization: getUserCurrentOrganization(state),
    isAccount: source === 'accounts',
  };
}

ExclusionReasonPage.propTypes = {
  organization: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}),
  }).isRequired,
};

ExclusionReasonPage.contextTypes = {
  router: PropTypes.shape({}),
};

export default connect(mapStateToProps)(ExclusionReasonPage);
